import React from 'react';
import { useLocale } from '../../contexts/LocaleContext';
import { Button } from '../ui/button';
import { Link } from '../ui/link';

export const AdminAccessDenied: React.FC = () => {
  const { t } = useLocale();

  return (
    <div className="mx-auto max-w-[900px] text-center">
      <h1 className="mb-2 text-2xl font-semibold text-foreground">{t('access_denied')}</h1>
      <p className="mb-6 text-muted-foreground">{t('no_permission')}</p>
      <Button asChild variant="inverse">
        <Link to="/">{t('go_to_home')}</Link>
      </Button>
    </div>
  );
};
